import DataManager from 'utils/DataManager/dataManager';
import { EventTypes } from 'typings/enums';
import { IAmountEvent } from 'nomst/Stores/Decision/Constants/amountEvent';
import { IEventDataManager } from 'typings/dataManagers';
import { IConversationItemEvent } from 'nomst/Stores/Decision/Constants/conversationItemEvent';
import { IPerformanceRatingEvent } from 'nomst/Stores/Decision/Constants/performanceRatingEvent';
import { ITeamNotifyManagersEvent } from 'nomst/Stores/Decision/Constants/teamNotifyManagersEvent';

class EventDataManager extends DataManager implements IEventDataManager {
    async sendEvents(
        masterAccountId: string,
        cycleId: Nullable<number>,
        eventsParameters: IAmountEvent[]|IEmployeeEvent[]): Promise<void> {
        const route = cycleId ?
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/events` :
            `/api/accounts/${masterAccountId}/team/employees/events`;
        const receive = () => this._postDataRequest<typeof eventsParameters, void>(
            route,
            eventsParameters);

        await this.getData<void>(receive, false);
    }

    async sendPerformanceRatingEvent(
        masterAccountId: string,
        cycleId: number,
        employeeSourceId: string,
        eventParameter: IPerformanceRatingEvent): Promise<void> {
        const receive = () => this._postDataRequest<typeof eventParameter, void>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/${EventTypes.UpdatePerformanceRating}?employeeSourceId=${encodeURIComponent(employeeSourceId)}`,
            eventParameter);

        await this.getData<void>(receive, false);
    }

    async sendConversationItemEvent(
        masterAccountId: string,
        employeeSourceId: string,
        eventParameter: IConversationItemEvent): Promise<void> {
        const receive = () => this._postDataRequest<typeof eventParameter, void>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/employees/conversations/events?employeeSourceId=${encodeURIComponent(employeeSourceId)}`,
            eventParameter);
        await this.getData<void>(receive, false);
    }

    async sendPromotionCommentEvent(
        masterAccountId: string,
        employeeSourceId: string,
        cycleId: number,
        promotionId: string,
        eventParameter: IEventNoMst): Promise<void> {
        const receive = () => this._postDataRequest<typeof eventParameter, void>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/promotion/${promotionId}/comments/events?employeeSourceId=${encodeURIComponent(employeeSourceId)}`,
            eventParameter);
        await this.getData<void>(receive, false);
    }

    async sendNotifyManagersEvent(
        masterAccountId: string,
        cycleId: number,
        eventParameter: ITeamNotifyManagersEvent): Promise<void> {
        const receive = () => this._postDataRequest<ITeamNotifyManagersEvent, void>(
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/notifyManagers`,
            eventParameter);

        await this.getData<void>(receive, true);
    }

    async sendEmployeeEvent(
        masterAccountId: string,
        employeeSourceId: string,
        cycleId: number,
        eventParameter: IEventNoMst): Promise<void> {
        const receive = () => this._postDataRequest<typeof eventParameter, void>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/employeeevents?employeeSourceId=${encodeURIComponent(employeeSourceId)}`,
            eventParameter);
        await this.getData<void>(receive, false);
    }

    async saveEmployeeEvent(
        masterAccountId: string,
        cycleId: number,
        employeeSourceId: string,
        eventType: string,
        eventParameter: IEventNoMst): Promise<void> {
        const receive = () => this._postDataRequest<typeof eventParameter, void>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/${eventType}?employeeSourceId=${encodeURIComponent(employeeSourceId)}`,
            eventParameter);
        await this.getData<void>(receive, false);
    }

    async sendEvent(
        masterAccountId: string,
        employeeSourceId: string,
        cycleId: number,
        eventParameter: IEventNoMst): Promise<void> {
        const receive = () => this._postDataRequest<typeof eventParameter, void>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/event?employeeSourceId=${encodeURIComponent(employeeSourceId)}`,
            eventParameter);
        await this.getData<void>(receive, false);
    }
}

export { EventDataManager };
export default EventDataManager;